import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import Button from '@/components/ui/Button';

export default function SubscriptionSuccess() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-cream-200 p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
          <CheckCircle2 className="h-10 w-10 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-taupe-900 mb-2">¡Suscripción autorizada!</h1>
        <p className="text-taupe-600 mb-6">
          Tu suscripción fue autorizada correctamente en Mercado Pago.
          El primer cobro se procesará en las próximas horas.
        </p>
        <Link to="/dashboard/billing">
          <Button className="w-full bg-taupe-700 hover:bg-taupe-800 text-cream-50">
            Ir a Facturación
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
